import { AlertTriangle } from "lucide-react";

const BackupCooldownAlert = ({getRemainingTime}) => {
  return (
    <div className="mb-4 flex items-start gap-3 rounded-2xl border border-[#FAD6A5] bg-[#FFF8EE] p-4 text-sm text-[#856404]">
      <div className="shrink-0 mt-0.5">
        <AlertTriangle size={20} />
      </div>
      <div>
        <div className="font-bold mb-1">دسترسی محدود</div>
        <div className="leading-[1.8] opacity-90">
          شما در ۲۴ ساعت گذشته از داده‌ها پشتیبان تهیه کرده‌اید.
          <br />
          برای تهیه نسخه پشتیبان جدید، باید{" "}
          <strong>{getRemainingTime()}</strong> صبر کنید.
        </div>
      </div>
    </div>
  );
};

export default BackupCooldownAlert;
